import { c as _c } from "react/compiler-runtime";
import { useCurrency } from "@opensea/navigation";
import { useTranslations } from "next-intl";
import { TokenPrice } from "@/components/price/TokenPrice";
import { UsdPrice } from "@/components/price/UsdPrice";
export function StagePriceDisplay(t0) {
  const $ = _c(19);
  const {
    display: t1,
    stage
  } = t0;
  const display = t1 === undefined ? "primary" : t1;
  const t = useTranslations("StagePriceDisplay");
  const {
    currency
  } = useCurrency();
  if (display === "secondary" && currency === "usd") {
    return null;
  }
  const Component = display === "primary" ? TokenPrice : UsdPrice;
  const tokenDetailsMap = stage.tokenDetailsMap;
  if (!tokenDetailsMap || Object.keys(tokenDetailsMap).length === 0) {
    const t2 = stage.eligiblePrice ?? stage.price;
    let t3;
    if ($[0] !== Component || $[1] !== t2) {
      t3 = <Component price={t2} />;
      $[0] = Component;
      $[1] = t2;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let lowestPrice;
  let t2;
  let t3;
  if ($[3] !== Component || $[4] !== tokenDetailsMap) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const prices = Object.values(tokenDetailsMap).map(_temp);
      const uniquePrices = prices.filter(_temp2);
      if (uniquePrices.length === 0) {
        t3 = null;
        break bb0;
      }
      if (uniquePrices.length === 1) {
        t3 = <Component price={uniquePrices[0]} />;
        break bb0;
      }
      const sortedPrices = uniquePrices.sort(_temp3);
      if (sortedPrices.length === 0) {
        t3 = null;
        break bb0;
      }
      lowestPrice = sortedPrices[0];
      t2 = sortedPrices.at(-1);
    }
    $[3] = Component;
    $[4] = tokenDetailsMap;
    $[5] = lowestPrice;
    $[6] = t2;
    $[7] = t3;
  } else {
    lowestPrice = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  const highestPrice = t2;
  let t4;
  if ($[8] !== Component || $[9] !== highestPrice || $[10] !== lowestPrice || $[11] !== t) {
    let t5;
    if ($[13] !== Component || $[14] !== lowestPrice) {
      t5 = () => <Component price={lowestPrice} />;
      $[13] = Component;
      $[14] = lowestPrice;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== Component || $[17] !== highestPrice) {
      t6 = () => <Component price={highestPrice} />;
      $[16] = Component;
      $[17] = highestPrice;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    t4 = t.rich("priceRange", {
      lowestPrice: t5,
      highestPrice: t6
    });
    $[8] = Component;
    $[9] = highestPrice;
    $[10] = lowestPrice;
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp3(a, b) {
  return (a.usd || 0) - (b.usd || 0);
}
function _temp2(price, index, arr) {
  return arr.findIndex(p => p.usd === price.usd) === index;
}
function _temp(details) {
  return details.eligiblePrice ?? details.price;
}